module.exports = __webpack_public_path__ + "img/DSC_0049.26ab424d.jpg";